import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import StyledButton from "../../../../common/models/Button";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "900px",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  resetChangesButton: {
    border: "1px solid #000000",
    color: "#000000",
    fontWeight: 600,
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    marginTop: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
      height: "30px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(4),
  },
  backButton: {
    backgroundColor: "#555",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "2px",
  },
  saveButton: {
    backgroundColor: "#f26522",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#d4551a",
    },
  },
}));

const ShipmentStatusTab = (props) => {
  const { featuresAccess, sponsorId } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isUpdated, setIsUpdated] = useState(false);
  const [savingStates, setSavingStates] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  const [shipmentStatuses, setShipmentStatuses] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
const [renameValue, setRenameValue] = useState("");
  
  // Get edit access from featuresAccess
  const canEdit = featuresAccess?.editSponsorNetworkDetails ?? false;

  const fetchShipmentStatuses = async () => {
    setError(null); // Reset error state
    setLoading(true); // Show loading spinner

    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchFGStatusesDirect/false`; // API endpoint
      const response = await axios.get(url);
      const data = response?.data?.data;

      //console.log("API Shipment Status Data:", data);

      if (response.data?.status === true || response.data?.status === "true") {
        const list = data?.shipmentStatuses || [];

        // Map the API response to match the expected structure
        const formattedStatuses = list.map((item, index) => ({
          id: item.status_id || `ID-${index + 1}`, // Use ID from API or generate one
          name: item.status_name || "", // Use name from API or fallback
          selected: !!item.activated, // Convert activation state to boolean
          type: item.status_type,
          isNew: false,
          lastUpdatedBy: item.last_updated_by,

          newStatusName: item.newStatusName , // Default to empty string for fetched statuses
        }));

        setShipmentStatuses(formattedStatuses); // Update state with formatted statuses
      } else {
        console.error(
          "Failed to fetch shipment statuses:",
          response.data?.message
        );
        setError(
          response.data?.message || "Failed to fetch shipment statuses."
        );
      }
    } catch (error) {
      console.error("Error fetching shipment statuses:", error);
      setError("An error occurred while fetching shipment statuses.");
    } finally {
      setLoading(false); // Hide loading spinner
    }
  };
  useEffect(() => {
    fetchShipmentStatuses();
  }, []);

  const addShipmentStatuses = async (index) => {
    const statusToAdd = shipmentStatuses[index]; // Get the status to add
    if (!statusToAdd.name?.trim() || savingStates[index]) return;
    setSavingStates((prev) => ({ ...prev, [index]: true }));
    try {
      // Prepare the payload for the API
      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"), // Example ecosystemId
        saslBatchStatusesList: [
          {
            // status_id: statusToAdd.id, // Use the ID if available, otherwise null
            status_name: statusToAdd.name, // Name of the Shipment status
            status_type: "New", // Mark as a new status
            object_type: "Shipment", // Set the object type to "Shipment"
            markForDelete: false,
            activated: statusToAdd.selected, // Default to false if not set
          },
        ],
      };

      //console.log(payload, "Payload for adding Shipment Status"); // Debugging

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addSASLBatchStatuses`; // API endpoint
      const response = await axios.post(url, payload);

      if (response.data?.status === true || response.data?.status === "true") {
        //console.log("Shipment status added successfully:", response.data);
        fetchShipmentStatuses();
           props.setShipmentStatus((prev) => !prev);
        // Update the state to mark the status as saved
        setShipmentStatuses((prev) =>
          prev.map((status, i) =>
            i === index
              ? { ...status, id: response.data?.data?.id, isNew: false }
              : status
          )
        );
      } else {
        console.error("Failed to add Shipment status:", response.data?.message);
        setError(response.data?.message || "Failed to add Shipment status.");
      }
    } catch (error) {
      console.error("Error adding Shipment status:", error);
      setError("An error occurred while adding the Shipment status.");
    }
    setSavingStates((prev) => ({ ...prev, [index]: false }));
  };

  // const handleNextClick = async () => {
  //   console.log("handleNextClick called");
  //   try {
  //     // Validate that at least one shipment status is selected
  //     const isAnyStatusSelected = shipmentStatuses.filter(
  //       (status) => status.isUpdated
  //     );
  //     if (!isAnyStatusSelected.length) {
  //       console.log("No updates detected. Proceeding to the next step.");
  //       props.handleNext(); // Directly move to the next tab
  //       return;
  //     }
  //     // if (!isAnyStatusSelected.length) {
  //     //   setErrorMessage("Please activate at least one shipment status.");
  //     //   console.log("Validation failed: No shipment status selected");
  //     //   return;
  //     // }
  //     if (shipmentStatuses.every((status) => !status.selected)) {
  //       setErrorMessage("Please enable at least one in toggle mode.");
  //       return;
  //     }

  //     // Prepare the payload for the API
  //     const payload = {
  //       sponsorId: 2, // Example sponsorId
  //       ecosystemId: localStorage.getItem("ecosystemId"), // Example ecosystemId
  //       shipmentStatuses: isAnyStatusSelected.map((status) => ({
  //         status_id: status.id, // ID of the shipment status
  //         status_name: status.name, // Name of the shipment status
  //         activated: status.selected, // Activation state
  //         newStatusName: status.newName, // New name if updated
  //         status_type: status.type, // Mark as a new status
  //         object_type: "Shipment",
  //         markForDelete: false, // Default to false
  //       })),
  //       batchStatuses: [], // Empty for this tab
  //       poStatuses: [], // Empty for this tab
  //     };

  //     console.log(payload, "Payload for updating Shipment Statuses"); // Debugging

  //     // Call the API
  //     const url = `${appUrl}/Pharma%20Contract%20Manufacturing/N1/sh1/Pharma%20Co/Admin/updateFGStatuses`;
  //     const response = await axios.post(url, payload);

  //     // Handle API response
  //     if (response.data?.status === true || response.data?.status === "true") {
  //       console.log("Shipment statuses updated successfully:", response.data);

  //       // Refresh the shipment statuses
  //       await fetchShipmentStatuses();

  //       // Move to the next tab
  //       if (props.handleNext) {
  //         props.handleNext();
  //       }
  //     } else {
  //       console.error(
  //         "Failed to update shipment statuses:",
  //         response.data?.message
  //       );
  //       setErrorMessage(
  //         response.data?.message || "Failed to update shipment statuses."
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error updating shipment statuses:", error);
  //     setErrorMessage(
  //       "An error occurred while updating shipment statuses. Please try again."
  //     );
  //   }
  // };
const handleSaveChanges = async () => {
    //console.log("handleNextClick called");
    try {
      // Validate that at least one shipment status is selected
      const isAnyStatusSelected = shipmentStatuses.filter(
        (status) => status.isUpdated
      );
      if (!isAnyStatusSelected.length) {
        //console.log("No updates detected. Proceeding to the next step.");
       
        return;
      }
      // if (!isAnyStatusSelected.length) {
      //   setErrorMessage("Please activate at least one shipment status.");
      //   console.log("Validation failed: No shipment status selected");
      //   return;
      // }
      if (shipmentStatuses.every((status) => !status.selected)) {
        setErrorMessage("Please enable at least one in toggle mode.");
        return;
      }

      // Prepare the payload for the API
      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"), // Example ecosystemId
        shipmentStatuses: isAnyStatusSelected.map((status) => ({
          status_id: status.id, // ID of the shipment status
          status_name: status.name, // Name of the shipment status
          activated: status.selected, // Activation state
          newStatusName: status.newStatusName, // New name if updated
          status_type: status.type, // Mark as a new status
          object_type: "Shipment",
          markForDelete: false, // Default to false
        })),
        batchStatuses: [], // Empty for this tab
        poStatuses: [], // Empty for this tab
      };

      //console.log(payload, "Payload for updating Shipment Statuses"); // Debugging

      // Call the API
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateFGStatuses`;
      const response = await axios.post(url, payload);

      // Handle API response
      if (response.data?.status === true || response.data?.status === "true") {
        //console.log("Shipment statuses updated successfully:", response.data);

        // Refresh the shipment statuses
        await fetchShipmentStatuses();
setIsUpdated(false); 
        // Move to the next tab
      
      } else {
        console.error(
          "Failed to update shipment statuses:",
          response.data?.message
        );
        setErrorMessage(
          response.data?.message || "Failed to update shipment statuses."
        );
      }
    } catch (error) {
      console.error("Error updating shipment statuses:", error);
      setErrorMessage(
        "An error occurred while updating shipment statuses. Please try again."
      );
    }
  };
  const handleDelete = async (index) => {
    try {
      const statusToDelete = shipmentStatuses[index]; // Get the status to delete

      // If the status is new (not saved), delete it internally
      if (statusToDelete.isNew) {
        setShipmentStatuses((prev) => prev.filter((_, i) => i !== index));
       
        return;
      }

      // Prepare the payload for the API
      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"), // Example ecosystemId
        shipmentStatuses: [
          {
            status_id: statusToDelete.id, // ID of the shipment status
            status_name: statusToDelete.name, // Name of the shipment status
            activated: statusToDelete.selected, // Current activation state
            newStatusName: statusToDelete.newStatusName,
            markForDelete: true, // Mark the status for deletion
            status_type: statusToDelete.type, // Mark as a new status
            object_type: "Shipment",
          },
        ],

        batchStatuses: [], // Empty for this tab
        poStatuses: [], // Empty for this tab
      };

      //console.log(payload, "Payload for deleting Shipment Status"); // Debugging

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateFGStatuses`; // API endpoint
      const response = await axios.post(url, payload);

      if (response.data?.status === true || response.data?.status === "true") {
        //console.log("Shipment status deleted successfully:", response.data);
        await fetchShipmentStatuses();
         props.setShipmentStatus((prev) => !prev);
        // Update the state to remove the deleted status
        setShipmentStatuses((prev) => prev.filter((_, i) => i !== index));
      } else {
        console.error(
          "Failed to delete Shipment status:",
          response.data?.message
        );
        setError(response.data?.message || "Failed to delete Shipment status.");
      }
    } catch (error) {
      console.error("Error deleting Shipment status:", error);
      setError("An error occurred while deleting the Shipment status.");
    }
  };

  const handleToggle = (index) => {
    const updated = [...shipmentStatuses];
    updated[index].selected = !updated[index].selected;
    updated[index].isUpdated = true;
    setShipmentStatuses(updated);
     setIsUpdated(true);
  };

  const handleNameChange = (index, value) => {
    const updated = [...shipmentStatuses];
    updated[index].name = value;
    setShipmentStatuses(updated);
    setIsUpdated(true);
  };
   const handleResetChanges = () => {
    if (isUpdated) {
      fetchShipmentStatuses(); // Re-fetch the product types from the backend
      setIsUpdated(false); // Reset the update state
      setErrorMessage(""); // Clear any error messages
    }
  };

  // const handleDelete = (index) => {
  //   const updated = shipmentStatuses.filter((_, i) => i !== index);
  //   setShipmentStatuses(updated);
  // };

  const handleAddStatus = () => {
    //const nextId = (shipmentStatuses.length + 1).toString().padStart(2, "0");
    setShipmentStatuses([
      ...shipmentStatuses,
      {
        // id: nextId,
        name: "",
        selected: false,
        isNew: true,
      },
    ]);
  };

  // const handleCancel = (index) => {
  //   setShipmentStatuses((prev) =>
  //     prev.map((status, i) =>
  //       i === index
  //         ? {
  //             ...status,
  //             isEditing: false,
  //             name: status.originalName || status.name,
  //           }
  //         : status
  //     )
  //   );
  // };
  const handleCancel = (index) => {
    const statusToCancel = shipmentStatuses[index];

    // If the status is new, remove it from the state
    if (statusToCancel.isNew) {
      setShipmentStatuses((prev) => prev.filter((_, i) => i !== index));
      //console.log("New shipment status removed.");
      return;
    }

    // If the status is not new, revert its changes
    setShipmentStatuses((prev) =>
      prev.map((status, i) =>
        i === index
          ? {
              ...status,
              isEditing: false, // Reset editing state
              name: status.originalName || status.name, // Revert to original name
            }
          : status
      )
    );
    
  };

  return (
    <div
      className={classes.container}
      style={{ display: "flex", flexDirection: "column", gap: "24px" }}
    >
      {/* Table and Buttons Section */}
      <div style={{ display: "flex", gap: "40px", alignItems: "flex-start" }}>
      <Table className={`${classes.table} default-table-styles`}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Selection</TableCell>
            <TableCell className={classes.headerCell}>
              Shipment Status 
            </TableCell>
            <TableCell className={classes.headerCell} style={{ whiteSpace: "nowrap" }}>
             Renamed Shipment Status
            </TableCell>
            <TableCell className={classes.headerCell} style={{ whiteSpace: "nowrap" }}>
              Shipment Status ID
            </TableCell>
            <TableCell className={classes.headerCell}>Action</TableCell>
                 <TableCell className={classes.headerCell}>Last Updated By</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            // Show loading spinner when loading is true
            <TableRow>
              <TableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100px",
                  }}
                >
                  <CircularProgress />
                </div>
              </TableCell>
            </TableRow>
          ) : error ? (
            // Show error message when error exists
            <TableRow>
              <TableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60px",
                    backgroundColor: "#ffecec",
                    color: "#b00020",
                    border: "1px solid #ff9999",
                  }}
                >
                  <Typography>{error}</Typography>
                </div>
              </TableCell>
            </TableRow>
          ) : shipmentStatuses.length === 0 ? (
            // Show "No Data" message when batchStatuses is empty
            <TableRow>
              <TableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60px",
                    color: "#666",
                  }}
                >
                  <Typography>No Batch Statuses Found</Typography>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            // Render shipmentStatuses data when available
            shipmentStatuses.map((item, index) => (
              <TableRow key={item.id}>
                <TableCell className={classes.bodyCell}>
                  <Switch
                    checked={item.selected}
                    onChange={() => handleToggle(index)}
                    classes={{ switchBase: classes.switchBase }}
                    disabled={!canEdit}
                  />
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {item.isNew ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <TextField
                        placeholder="Type Text Here"
                        value={item.name}
                        onChange={(e) =>
                          handleNameChange(index, e.target.value)
                        }
                        onBlur={(e) => {
                          const { value } = e.target;
                          // Trim leading and trailing spaces for string values
                          if (typeof value === "string" && value.trim() !== value) {
                            handleNameChange(index, value.trim());
                          }
                        }}
                        className={classes.textField}
                        variant="outlined"
                        inputProps={{
                          onBeforeInput: (e) => {
                            const allowedChars = /^[a-zA-Z0-9\s\-()]+$/;
                            if (!allowedChars.test(e.data)) {
                              e.preventDefault();
                            }
                          }
                        }}
                      />
                      <div className={classes.inlineActions}>
                        <IconButton
                          onClick={() => handleCancel(index)}
                          className={classes.iconBtn}
                        >
                          <CancelIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => addShipmentStatuses(index)}
                          className={classes.iconBtn}
                          disabled={
                            !item.name?.trim() ||
                            shipmentStatuses.some(
                              (s, i) =>
                                i !== index &&
                                s.name?.trim().toLowerCase() === item.name?.trim().toLowerCase()
                            ) || savingStates[index]
                          }
                        >
                          <SaveIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </div>
                  ) : (
                    item.name
                  )}
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {!item.isNew && (
                    editingIndex === index ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <TextField
                          value={renameValue}
                          onChange={e => setRenameValue(e.target.value)}
                          onBlur={(e) => {
                            const { value } = e.target;
                            // Trim leading and trailing spaces for string values
                            if (typeof value === "string" && value.trim() !== value) {
                              setRenameValue(value.trim());
                            }
                          }}
                          autoFocus
                          size="small"
                          variant="outlined"
                          placeholder="Rename Shipment Status"
                          className={classes.textField}
                          style={{ marginRight: 8 }}
                          inputProps={{
                            onBeforeInput: (e) => {
                            const allowedChars = /^[a-zA-Z0-9\s\-()]+$/;
                            if (!allowedChars.test(e.data)) {
                            e.preventDefault();
                          }
                    }
                  }}
                        />
                        <div className={classes.inlineActions}>
                          <IconButton
                            onClick={() => setEditingIndex(null)}
                            className={classes.iconBtn}
                          >
                            <CancelIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            onClick={async () => {
                              const updated = [...shipmentStatuses];
                              updated[index].newStatusName = renameValue;
                              updated[index].isUpdated = true;
                              setShipmentStatuses(updated);
                              setEditingIndex(null);
                              await handleSaveChanges();
                            }}
                            className={classes.iconBtn}
                          >
                            <SaveIcon fontSize="small" />
                          </IconButton>
                        </div>
                      </div>
                    ) : (
                        <span style={{ display: "flex", alignItems: "center" }}>
                        {item.newStatusName || ""}
                        {canEdit && (
                        <IconButton
                          size="small"
                          onClick={() => {
                            setEditingIndex(index);
                            setRenameValue(item.newStatusName || "");
                          }}
                          style={{ marginLeft: 4 }}
                        >
                          <EditIcon style={{ color: "orange" }} />
                        </IconButton>
                        )}
                      </span>
                    )
                  )}
                </TableCell>
                <TableCell className={classes.bodyCell}>{item.id}</TableCell>
                <TableCell className={classes.bodyCell}>
                  {canEdit && (item.isNew == true || item.type === "New" && item.lastUpdatedBy !== "support@schrocken.com") && (
                    
                    <IconButton
                      aria-label="delete"
                      onClick={() => handleDelete(index)}
                    >
                      <DeleteIcon className={classes.deleteIcon} />
                    </IconButton>
                  )}
                </TableCell>
                <TableCell className={classes.bodyCell}>{item.lastUpdatedBy}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      <div
                className={classes.buttonContainer}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "16px", // Adjusted gap between buttons
                  marginTop: "3px",
                  marginLeft: "0rem", // Added margin to create space between table and buttons
                }}
              >
                <Button
                  className={classes.saveButton}
                  type="button"
                  onClick={handleSaveChanges}
                  disabled={!isUpdated || !canEdit}
                  style={{
    
    opacity: !isUpdated || !canEdit ? 0.7 : 1, // Fade out when disabled
    color: "#fff", 
  }}
                >
                  Save Selection
                </Button>
      
                <Button
                  className={classes.resetChangesButton}
                  type="button"
                  onClick={handleResetChanges}
                   disabled={!isUpdated || !canEdit} // or whatever your "no changes" condition is
  style={{
    opacity: !isUpdated || !canEdit ? 0.8 : 1, // Fade out when disabled
  }}
                >
                  Reset Selection
                </Button>
              </div>
            </div>
      {errorMessage && (
        <div style={{ color: "red", marginTop: 10 }} className="error-message">
          {errorMessage}
        </div>
      )}

      {canEdit && (
        <Button
          variant="outlined"
          onClick={handleAddStatus}
          className={classes.addButton}
        >
          <span className={classes.addIconCircle}>+</span>
          Add New Shipment Status
        </Button>
      )}

      {/* <div className={classes.footer}>
        <Button
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          &lt; Back
        </Button>
        <StyledButton
          className={classes.saveButton}
          // onClick={() => {
          //   if (isUpdated) {
          //     handleNextClick(); // Call API and move to the next tab if updates are made
          //   } else {
          //     props.handleNext(); // Directly move to the next tab if no updates are made
          //   }
          // }}
          onClick={() => {
            handleNextClick(); // Call API and move to the next tab if updates are made
          }}
        >
          Save & Next
        </StyledButton>
      </div> */}
    </div>
  );
};

export default ShipmentStatusTab;
